<template>
  <b-modal
    :id="modalId"
    modal-class="modal-style function-modal"
    ref="modal"
    v-model="showModal"
  >
    <!-- :id="`product-modal${id}`" -->
    <button class="modal-close-btn" @click="handleHideModal">
      <img src="~@/assets/img/svg/icn_close.svg" alt="" />
    </button>
    <div class="product-info">
      <div class="product-info__img">
        <img :src="product.photo" alt="" />
      </div>

      <div class="product-info__detail">
        <div class="product-info__detail-name">
          {{ product.name }}
        </div>

        <div class="product-info__detail-discount">
          <div v-if="isHaveCombination" class="one-plan">
            {{ combinationName }}
          </div>
        </div>

        <div class="product-info__detail-price">$ {{ productSpecPrice }}</div>
      </div>
    </div>

    <div class="specification-area">
      <OneSpecification
        v-for="(specCategory, index) in modalProduct.spec_categories"
        :key="index"
        v-model="specCategory.spec"
        :item="specCategory"
      />
      <!-- <OneSpecification v-model="size" :specOption="sizeOption" /> -->
    </div>

    <div class="more-offers">
      <div class="more-offers__text-row">
        <div class="more-offers__title">
          更多優惠
        </div>
        <div class="more-offers__alert">
          優惠內容僅能三選一折抵
        </div>

        <button
          class="more-btn more-offer-btn"
          :class="offerShowMore ? 'active' : ''"
          @click="offerShowMore = !offerShowMore"
        >
          {{ showOfferText }}
          <div class="icon-arrow_d"></div>
        </button>
      </div>

      <b-collapse v-model="offerShowMore" class="more-offers__collapse">
        <div class="collapse-in">
          <div class="single-input-field">
            <p class="input-title">折扣(折)</p>

            <div class="custom-input">
              <input
                type="text"
                placeholder="如9折輸入9 , 85折輸入85"
                autocomplete="off"
                class="custom-text"
                v-model="percentageDiscountAmount"
              />
              <div class="unit">折</div>
            </div>
          </div>

          <div class="single-input-field">
            <p class="input-title">折價(元)</p>

            <div class="custom-input">
              <input
                type="text"
                placeholder="請輸入折抵價格"
                autocomplete="off"
                class="custom-text"
                v-model="priceDiscountAmount"
              />
              <div class="unit">元</div>
            </div>
          </div>

          <div class="giveaway">
            <div class="giveaway__title">
              是否設為贈品
            </div>
            <div
              class="switch"
              @click="toggleSwitch"
              :class="{ on: isGiveaway }"
            >
              <div class="btn"></div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>

    <div class="amount">
      <div class="amount__title">
        數量
      </div>

      <div class="count-area">
        <a href="#" @click.prevent="handleMinus">
          <span class="icon-icon_less"></span>
        </a>
        <div title="1" class="quantity">{{ currentQuantity }}</div>
        <a href="#" @click.prevent="handlePlus">
          <span class="icon-icon_add"></span>
        </a>
      </div>
    </div>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="addToCart">
        {{ updateAction === true ? '更新購物車' : '加入購物車' }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import OneSpecification from '@/components/Modal/ProductModal/OneSpecification';
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  props: {
    id: {
      type: String,
      default() {
        return 'purchase-product';
      }
    },
    product: {
      type: Object,
      required: true
    },
    push: {
      type: Boolean,
      default() {
        return false;
      }
    },
    //在購物車裡的index
    productIndex: {
      type: Number,
      required: false
    }
  },
  components: {
    OneSpecification
  },
  computed: {
    ...mapGetters('order', ['index']),
    updateAction() {
      return this.productIndex >= 0;
    },
    modalId() {
      return `product-modal-${this.id}`;
    },
    productParams() {
      return Object.assign(this.modalProduct, {
        id: this.index,
        in_cart: true,
        model_id: this.productSpecId,
        price: this.productSpecPrice,
        count: this.currentQuantity,
        discount_type: this.discountType,
        discount_number: this.discountNumber,
        product_spec: this.productSpec,
        combination_name: this.isHaveCombination ? this.combination.name : null
      });
    },
    combination() {
      return this.product.combination;
    },
    isHaveCombination() {
      return this.combination != null;
    },
    combinationName() {
      if (this.isHaveCombination) {
        return this.combination.name;
      } else {
        return '';
      }
    },
    discountNumber: {
      get() {
        switch (this.discountType) {
          case '1':
            return this.productSpec.price;

          case '2':
            return this.percentageDiscountAmount;

          case '3':
            return this.priceDiscountAmount;

          case '5':
            return this.combination.discount_number;

          default:
            return 0;
        }
      },

      set(value) {
        switch (this.discountType) {
          case '1':
            this.isGiveaway = true;
            break;

          case '2':
            this.percentageDiscountAmount = value;
            break;

          case '3':
            this.priceDiscountAmount = value;
            break;

          default:
            break;
        }
      }
    },
    productSpec() {
      let product = this.modalProduct;

      let productSpec = undefined;

      if (product.spec_categories == undefined) {
        return undefined;
      }

      let productSpecCategoryCount = product.spec_categories.length;

      if (productSpecCategoryCount == 0) {
        productSpec = product.product_specs[0];
      } else if (productSpecCategoryCount == 1) {
        productSpec = product.product_specs.find(
          product_spec =>
            product_spec.first_spec_id == product.spec_categories[0].spec
        );
      } else if (productSpecCategoryCount == 2) {
        productSpec = product.product_specs.find(
          product_spec =>
            product_spec.first_spec_id == product.spec_categories[0].spec &&
            product_spec.second_spec_id == product.spec_categories[1].spec
        );
      }

      return productSpec;
    },
    productSpecId() {
      return _.get(this.productSpec, 'product_spec_id');
    },
    productSpecPrice() {
      return _.get(this.productSpec, 'price') ?? this.product.max_price;
    },
    showOfferText() {
      if (this.offerShowMore) {
        return '收合優惠';
      }

      return '展開優惠';
    }
  },
  data() {
    return {
      discountShowMore: false,
      offerShowMore: false,
      isGiveaway: false,
      currentQuantity: 1,
      showModal: false,
      percentageDiscountAmount: null,
      priceDiscountAmount: null,
      discountType: '0',
      modalProduct: null
    };
  },
  watch: {
    product: {
      deep: true,
      immediate: true,
      handler(val) {
        this.modalProduct = _.cloneDeep(val);
      }
    },
    showModal() {
      if (this.showModal == false) {
        this.reset();
      } else {
        this.offerShowMore = this.product.in_cart ?? false;
        this.currentQuantity = this.product.count ?? 1;
        this.discountType =
          this.push === false
            ? this.product.discount_type
            : this.isHaveCombination
            ? '5'
            : '0';
        this.discountNumber =
          this.push === false
            ? this.product.discount_number
            : this.discountNumber;
      }
    },
    isGiveaway(next) {
      if (next == true) {
        this.useGiveawayDiscount();
      }
    },
    percentageDiscountAmount(next) {
      if (next < 0 || next > 100) {
        alert('輸入折扣有誤,折扣範圍 0 ~ 100');
        this.percentageDiscountAmount = null;
      }

      if (next != null && next != '') {
        this.usePercentageDiscount();
      }
    },
    priceDiscountAmount(next) {
      if (next < 0 || next > this.productSpecPrice * this.currentQuantity) {
        alert(
          '輸入折價有誤,折價範圍 0 ~ ' +
            this.productSpecPrice * this.currentQuantity
        );
        this.priceDiscountAmount = null;
      }

      if (next != null && next != '') {
        this.usePriceDiscount();
      }
    }
  },
  methods: {
    ...mapActions('order', ['addProduct', 'updateProduct']),
    toggleSwitch() {
      this.isGiveaway = !this.isGiveaway;
    },
    handlePlus() {
      this.currentQuantity = this.currentQuantity + 1;
    },
    handleMinus() {
      let count = this.currentQuantity - 1;
      count <= 0 ? (this.currentQuantity = 1) : (this.currentQuantity = count);
    },
    handleHideModal() {
      this.$refs.modal.hide();
    },
    reset() {
      this.discountShowMore = false;
      this.offerShowMore = false;
      this.isGiveaway = false;
      this.currentQuantity = 1;
      this.discountType = '0';
      this.percentageDiscountAmount = null;
      this.priceDiscountAmount = null;
    },
    addToCart() {
      if (this.checkProductCategory()) {
        if (this.productSpec == undefined || this.productSpec.in_stock == 0) {
          alert('此規格暫無庫存');

          return false;
        }

        // 判斷庫存量
        if (
          this.productSpec.in_stock != null &&
          this.currentQuantity > this.productSpec.in_stock
        ) {
          alert('超過庫存數量 ' + this.productSpec.in_stock);

          return false;
        }

        // 加入/更新購物車判斷優惠內容
        this.chooseDiscount();

        if (this.updateAction) {
          this.updateProduct({
            product: this.productParams,
            productIndex: this.productIndex
          });
        } else {
          this.addProduct({ product: this.productParams, push: this.push });
        }

        this.closeModal();
      }
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
    usePercentageDiscount() {
      this.discountType = '2';
      this.priceDiscountAmount = null;
      this.isGiveaway = false;
    },
    usePriceDiscount() {
      this.discountType = '3';
      this.percentageDiscountAmount = null;
      this.isGiveaway = false;
    },
    useGiveawayDiscount() {
      this.discountType = '1';
      this.percentageDiscountAmount = null;
      this.priceDiscountAmount = null;
    },
    useCombinationDiscount() {
      this.discountType = '5';
      this.isGiveaway = false;
      this.priceDiscountAmount = null;
      this.percentageDiscountAmount = null;
    },
    checkProductCategory() {
      let notSelectedSpec = false;

      this.modalProduct.spec_categories.forEach(specCategory => {
        if (specCategory.spec == '') {
          notSelectedSpec = true;
        }
      });

      if (notSelectedSpec) {
        alert('請選擇規格');

        return false;
      }

      return true;
    },
    chooseDiscount() {
      if (this.isGiveaway === true) {
        this.discountType = '1';
      } else if (
        this.percentageDiscountAmount != null &&
        this.percentageDiscountAmount != ''
      ) {
        this.discountType = '2';
      } else if (
        this.priceDiscountAmount != null &&
        this.priceDiscountAmount != ''
      ) {
        this.discountType = '3';
      } else {
        this.discountType = this.isHaveCombination ? '5' : '0';
      }
    }
  }
};
</script>
